import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ONE_PAGE_SECTIONS } from 'constants/businessToolSections/onePage';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormHeader } from 'components/_basic/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';
import { GLOBAL_FIELD_NAMES, globalPrefix } from 'components/BusinessToolForm/Sections/Global/form';

import { concatWithDot } from 'helpers/string';

export const ProductsOrServices: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = useCheckSubSectionAccess(ONE_PAGE_SECTIONS.PRODUCTS_SERVICES);

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('chapters.PRODUCTS_SERVICES')}
          section={ONE_PAGE_SECTIONS.PRODUCTS_SERVICES}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.products.mainProducts')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.MAIN_PRODUCTS_OR_SERVICES)}
      >
        {/* 1.3.1 */}
        <TextInputControl
          multiline
          control={control}
          id="onePage.products.mainProducts"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.MAIN_PRODUCTS_OR_SERVICES)}
          minRows={4}
          maxLength={1000}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.products.competitionAdvantage')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.COMPETITIVE_ADVANTAGE)}
      >
        {/* 1.3.3 */}
        <TextInputControl
          multiline
          control={control}
          id="onePage.products.competitionAdvantage"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.COMPETITIVE_ADVANTAGE)}
          minRows={4}
          maxLength={1000}
        />
      </FormSectionCard>
    </>
  );
};
